export const PREFIX = ""
export const API = 'https://cloud.stressrecoveryanalyzer.com'
export const SYNC_TARGET_API = ''
export const SETTING = {
  "title": "Stress & Recovery Analyzer Cloud Administrator Console",
}
